"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaBlockToJSON = exports.RosettaBlockFromJSONTyped = exports.RosettaBlockFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaBlockFromJSON(json) {
    return RosettaBlockFromJSONTyped(json, false);
}
exports.RosettaBlockFromJSON = RosettaBlockFromJSON;
function RosettaBlockFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'block_identifier': json['block_identifier'],
        'parent_block_identifier': _1.RosettaParentBlockIdentifierFromJSON(json['parent_block_identifier']),
        'timestamp': json['timestamp'],
        'transactions': (json['transactions'].map(_1.RosettaTransactionFromJSON)),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : _1.RosettaBlockMetadata1FromJSON(json['metadata']),
    };
}
exports.RosettaBlockFromJSONTyped = RosettaBlockFromJSONTyped;
function RosettaBlockToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'block_identifier': value.block_identifier,
        'parent_block_identifier': _1.RosettaParentBlockIdentifierToJSON(value.parent_block_identifier),
        'timestamp': value.timestamp,
        'transactions': (value.transactions.map(_1.RosettaTransactionToJSON)),
        'metadata': _1.RosettaBlockMetadata1ToJSON(value.metadata),
    };
}
exports.RosettaBlockToJSON = RosettaBlockToJSON;
//# sourceMappingURL=RosettaBlock.js.map